import React from "react"
import PropTypes from "prop-types"
import { values } from "lodash"

import { Link } from 'react-router'

import {
  ButtonGroup, Checkbox, FormGroup, FormControl, 
  ControlLabel, Modal, ListGroup, ListGroupItem
} from 'react-bootstrap'

import removeDiacritics from '../../lib/diacritics.js'
import { getText } from "../lib/text"
import Button from "../components/Button"


import "./Product.Relations.less"

const match = (term, prop) => (
  prop && removeDiacritics(prop).toLowerCase().replace(/\s/g, '').indexOf(term) >= 0
)

function filterByName(term, list) {
  const cleanTerm = removeDiacritics(term).toLowerCase().replace(/\s/g, '')

  return list.filter(p => (
    match(cleanTerm, p.name)
      || match(cleanTerm, p.chName)
      || match(cleanTerm, p._id)
  ))
}

class RelationList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      nameProduct: "",
      modal: false,
      clickado : null,
      citySame: true
    }
  }

  render() {
    const encontrado = this.props.list.some(el => el == this.state.clickado)
    const productsList = values(this.props.products)

    return (
      <React.Fragment>
        <div>
          <ListGroup>
            {
              this.props.list.length == 0 && (
                <i className="noneName">Ninguno</i>
              )
            }
            {
              this.props.list.map((productId, i) => (
                <ListGroupItem key={productId}>
                  <ButtonGroup>
                    <Button 
                      bsSize="xsmall"
                      tooltipText="Eliminar"
                      glyph="remove"
                      onClick={() => {
                        const newList = this.props.list.filter(j => j != productId)
                        this.props.onChange(newList)
                      }}
                    />
                    <Button 
                      glyph="chevron-up"
                      bsSize="xsmall"
                      onClick={() => {
                        if (i > 0) {
                          const cloneArray = this.props.list.slice()
                          const aux = cloneArray[i - 1]
                          cloneArray[i - 1] = cloneArray[i]
                          cloneArray[i] = aux
                          this.props.onChange(cloneArray)
                        }
                      }}
                      tooltipText="Mover arriba"
                      disabled={i == 0}
                    />
                    <Button 
                      bsSize="xsmall"
                      onClick={() => {
                        if (i < this.props.list.length - 1) {
                          const cloneArray = this.props.list.slice()
                          const aux = cloneArray[i + 1]
                          cloneArray[i + 1] = cloneArray[i]
                          cloneArray[i] = aux
                          this.props.onChange(cloneArray)
                        }
                      }}
                      disabled={i == this.props.list.length - 1}
                      glyph="chevron-down"
                      tooltipText="Mover abajo"
                    />
                    <div className="selectedList">
                      <Link to={`/private/product/${encodeURIComponent(this.props.products[productId]._id)}?`}>
                        <div>
                          <p>{ this.props.products[productId].name || "SIN NOMBRE" }</p>
                          <p>({ this.props.products[productId].chName || "SIN NOMBRE" })</p>
                        </div>
                      </Link>
                    </div>
                  </ButtonGroup>
                </ListGroupItem>
              ))
            }
          </ListGroup>
          
          <Button 
            glyph= "plus"
            onClick={() => this.setState({ modal: true })}
            label={getText("Añadir")} 
          />
        </div>

        { 
          this.state.modal && (
            <Modal className="productRelationModal" show onHide={() => this.setState({ clickado: null, modal: false })}>
              <Modal.Header>
                {getText("Añadir Producto")}
              </Modal.Header>
              <Modal.Body>
                <FormGroup>
                  <ControlLabel>Búsqueda</ControlLabel>
                  <FormControl 
                    value={this.state.nameProduct}
                    onChange={evt => this.setState({
                      nameProduct: evt.target.value
                    })
                    }
                  />
                  
                  <Checkbox
                    checked={this.state.citySame}
                    onChange={evt => this.setState({ citySame: evt.target.checked })}
                  >
                    Misma ciudad
                  </Checkbox>


                  <div className="modalList">
                  
                    <ListGroup className="listGroupModal"> 
                      {         
                        filterByName(
                          this.state.nameProduct, 
                          productsList.filter(p => (
                            (p._id != this.props.product._id) 
                            && (!this.state.citySame || p.city == this.props.product.city)
                          ))
                        )
                          .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                          .map((p) => (
                            <ListGroupItem
                              key={p._id}
                              bsStyle={p._id == this.state.clickado ? "success" : "none"}
                              className="listItemModal"
                              onClick={() => {
                                const newIdProd = p._id
                                this.setState({ clickado : newIdProd })
                              }}
                            >
                              { p.name || "SIN NOMBRE" } ({ p.chName || "SIN NOMBRE" }) 
                            </ListGroupItem>
                          ))
                      }   
                    </ListGroup>
                  </div>
                </FormGroup>
              </Modal.Body>
              <Modal.Footer>
                {
                  encontrado && (
                    <span className="modalfooter">Este producto ya esta en la lista</span>
                  )
                }
                <Button 
                  onClick={() => {
                    if (!encontrado) {
                      const newList = this.props.list.concat(this.state.clickado)
                      this.props.onChange(newList)
                      this.setState({ clickado: null, modal: false }) 
                    }
                  }}
                  disabled={!this.state.clickado || encontrado}
                >
                  {getText("Aceptar")}
                </Button>
              
                <Button onClick={() => this.setState({ clickado: null, modal: false })}>
                  {getText("Cancelar")}
                </Button>

              </Modal.Footer>
            </Modal>
          )
        } 
      </React.Fragment>
    )
  }
}

RelationList.propTypes = {
  products: PropTypes.objectOf(PropTypes.object).isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  product : PropTypes.object.isRequired
}

export default RelationList
